import { service } from '@ember/service';
import Route from '@ember/routing/route';
import type ReimaginedDataService from 'tio-employee/services/reimagined-data';

export default class AuthenticatedCareerPathwaysSkillsRoute extends Route {
  @service declare reimaginedData: ReimaginedDataService;

  async model() {
    const [skillsData, skillGaps] = await Promise.all([
      this.reimaginedData.fetchEmployeeSkills(),
      this.reimaginedData.fetchSkillGaps(),
    ]);

    return {
      ...skillsData,
      skillGaps,
    };
  }
}
